import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { ReviewFindingTarget, ReviewTargetKind } from 'api/journey-reviews/requests';

export type FindingTargetLabelProps = {
  target: ReviewFindingTarget;
};

const KIND_LABEL_KEY: Record<ReviewTargetKind, keyof (typeof locale)['en']> = {
  action: 'kindAction',
  trigger: 'kindTrigger',
  branch: 'kindBranch',
  field: 'kindField',
};

export const FindingTargetLabel = ({ target }: FindingTargetLabelProps) => {
  const { t } = useScopedTranslate(locale);
  const kind = t(KIND_LABEL_KEY[target.kind]);

  return (
    <Text
      font="regular12"
      color="textHelper"
      text={target.label ? `${kind} · ${target.label}` : kind}
    />
  );
};

export const locale = {
  en: {
    kindAction: 'Action',
    kindTrigger: 'Trigger',
    kindBranch: 'Branch',
    kindField: 'Field',
  },
};
